import React, { FunctionComponent, useState } from 'react';
import CreatePackCopyStep1Modal from '../components/CreatePackCopyStep1Modal';
import CreatePackCopyAutomaticModal from '../components/CreatePackCopyAutomaticModal';
import CreatePackCopyManualModal from '../components/CreatePackCopyManualModal';
import { SpecDetail } from '../types';
import { UploadMode } from '../components/CreatePackCopyStep1Modal';
import useURLParams from '../hooks/useURLParams';

interface UploadPackCopyProps {
    projectId: string;
}

type FlowStep = 'step1' | 'automatic' | 'manual';

interface PackCopyData {
    versionName: string;
    notes: string;
    uploadMode: UploadMode;
}

const UploadPackCopy: FunctionComponent<UploadPackCopyProps> = ({
    projectId,
}) => {
    const [currentStep, setCurrentStep] = useState<FlowStep>('step1');
    const [packCopyData, setPackCopyData] = useState<PackCopyData | null>(null);

    const { setParam } = useURLParams();

    const handleCloseModal = () => {
        setParam('modal', null);
    };

    const handleStep1Next = (data: {
        versionName: string;
        notes: string;
        uploadMode: UploadMode;
    }) => {
        setPackCopyData(data);
        if (data.uploadMode === 'automatic') {
            setCurrentStep('automatic');
        } else {
            setCurrentStep('manual');
        }
    };

    const handleBackToStep1 = () => {
        setCurrentStep('step1');
    };

    const handleManualFinish = (specs: SpecDetail[]) => {
        // TODO: Implement manual pack copy creation with specs
        console.log('Creating manual pack copy with specs:', specs);
        console.log('Pack copy data:', packCopyData);

        // For now, just close the modal
        handleCloseModal();
    };

    // Render the appropriate modal based on current step
    switch (currentStep) {
        case 'step1':
            return (
                <CreatePackCopyStep1Modal
                    onClose={handleCloseModal}
                    onNext={handleStep1Next}
                    initialData={
                        packCopyData
                            ? {
                                  versionName: packCopyData.versionName,
                                  notes: packCopyData.notes,
                                  uploadMode: packCopyData.uploadMode,
                              }
                            : undefined
                    }
                />
            );

        case 'automatic':
            return packCopyData ? (
                <CreatePackCopyAutomaticModal
                    onClose={handleCloseModal}
                    onBack={handleBackToStep1}
                    packCopyData={{
                        versionName: packCopyData.versionName,
                        notes: packCopyData.notes,
                    }}
                    projectId={projectId}
                />
            ) : null;

        case 'manual':
            return packCopyData ? (
                <CreatePackCopyManualModal
                    onClose={handleCloseModal}
                    onBack={handleBackToStep1}
                    onFinish={handleManualFinish}
                    packCopyData={{
                        versionName: packCopyData.versionName,
                        notes: packCopyData.notes,
                    }}
                    projectId={projectId}
                />
            ) : null;

        default:
            return null;
    }
};

export default UploadPackCopy;
